/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { DEFAULT_DETECTION_DATE_RANGE } from 'components/exceptions/constants'
import { DEFAULT_INSPECTIONS_PAGE_SIZE } from 'components/inspections/utils/inspectionListParams'

import type { DetectionDateRange } from 'components/exceptions/types'
import type { InspectionStateFilter, InspectionTripFilter } from 'components/inspections/constants'

export interface InspectionsFiltersState {
  search: string
  stateFilter: InspectionStateFilter
  tripFilter: InspectionTripFilter
  dateRange: DetectionDateRange
  pageSize: number
}

const initialState: InspectionsFiltersState = {
  search: '',
  stateFilter: 'all',
  tripFilter: 'all',
  dateRange: DEFAULT_DETECTION_DATE_RANGE,
  pageSize: DEFAULT_INSPECTIONS_PAGE_SIZE,
}

const inspectionsFiltersSlice = createSlice({
  name: 'inspectionsFilters',
  initialState,
  reducers: {
    setInspectionsSearch(state, action: PayloadAction<string>) {
      state.search = action.payload
    },
    setInspectionsStateFilter(state, action: PayloadAction<InspectionStateFilter>) {
      state.stateFilter = action.payload
    },
    setInspectionsTripFilter(state, action: PayloadAction<InspectionTripFilter>) {
      state.tripFilter = action.payload
    },
    setInspectionsDateRange(state, action: PayloadAction<DetectionDateRange>) {
      state.dateRange = action.payload
    },
    setInspectionsPageSize(state, action: PayloadAction<number>) {
      state.pageSize = action.payload
    },
    // The page size is a preference, not a filter: clearing filters keeps it.
    resetInspectionsFilters(state) {
      return { ...initialState, pageSize: state.pageSize }
    },
  },
})

export const {
  setInspectionsSearch,
  setInspectionsStateFilter,
  setInspectionsTripFilter,
  setInspectionsDateRange,
  setInspectionsPageSize,
  resetInspectionsFilters,
} = inspectionsFiltersSlice.actions

interface StateWithInspectionsFilters {
  inspectionsFilters?: InspectionsFiltersState
}

export const selectInspectionsFilters = (state: StateWithInspectionsFilters): InspectionsFiltersState =>
  state.inspectionsFilters ?? initialState

export default inspectionsFiltersSlice.reducer
